export const uiMarketoForm = {
    name: 'UI Marketo Form',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        munchkinId: {
            name: 'Munchkin id',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        formId: {
            name: 'Form id',
            type: 'Integer',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        munchkinIdStg: {
            name: 'Munchkin id stg',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        formIdStg: {
            name: 'Form id stg',
            type: 'Integer',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        text: {
            name: 'Text',
            type: 'RichText',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                { nodes: {} },
                {
                    enabledNodeTypes: [
                        'heading-1',
                        'heading-2',
                        'heading-3',
                        'heading-4',
                        'heading-5',
                        'heading-6',
                        'ordered-list',
                        'unordered-list',
                        'hr',
                        'blockquote',
                        'hyperlink'
                    ],
                    message: 'Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, and link to Url nodes are allowed'
                }
            ]
        },
        success: {
            name: 'Success',
            type: 'Link',
            linkType: 'Entry',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['uiBlock'] }]
        },
        successMessage: {
            name: 'Success message',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        errorMessage: {
            name: 'Error message',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        businessEmailValidation: {
            name: 'Business email validation',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiMarketoForm.js.map